import { render } from "./AddEditPhone.vue?vue&type=template&id=4dc9c7fb&scoped=true"
import script from "./AddEditPhone.vue?vue&type=script&lang=js"
export * from "./AddEditPhone.vue?vue&type=script&lang=js"

import "./AddEditPhone.vue?vue&type=style&index=0&id=4dc9c7fb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc9c7fb"]])

export default __exports__